import "react-native-reanimated";
import { AnonymousWidgetPos } from "../types";

export function containsOverflowingPositions(
  positions: AnonymousWidgetPos[],
  numberOfColumns: number = 4,
  numberOfRows: number = 4
) {
  "worklet";
  for (let i = 0; i < positions.length; i++) {
    const pos = positions[i];

    if (
      pos.x + pos.w > 2 ||
      pos.x < 0 ||
      pos.y < 0 ||
      pos.y + pos.h > numberOfRows ||
      pos.c > numberOfColumns - 1 ||
      pos.c < 0
    ) {
      return true;
    }
  }
  return false;
}
